/* import __COLOCATED_TEMPLATE__ from './device-delete-confirmation.hbs'; */
import templateOnly from '@ember/component/template-only';
export default templateOnly();